(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jolly-learning-overview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-jlo-section]');

    sections.forEach((section) => {
      const yearButtons = section.querySelectorAll('[data-jlo-year]');
      const cells = section.querySelectorAll('[data-jlo-years]');
      const routes = section.querySelectorAll('[data-jlo-route]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      const enableStickyActions = () => {
        if (mobileQuery.matches) {
          section.classList.add('jlo--sticky-actions');
        }
      };

      const syncStickyActions = () => {
        if (!mobileQuery.matches) {
          section.classList.remove('jlo--sticky-actions');
        }
      };

      const applyYear = (year) => {
        yearButtons.forEach((button) => {
          const active = button.dataset.jloYear === year;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        cells.forEach((cell) => {
          const years = (cell.dataset.jloYears || '').split(' ');
          cell.classList.toggle('is-active', years.includes(year) || years.includes('all'));
        });

        routes.forEach((route) => {
          const active = route.dataset.jloRoute === year;
          route.classList.toggle('is-active', active);
          route.hidden = !active;
        });

        section.dataset.jloActiveYear = year;
      };

      const setYear = (year, shouldStick = false) => {
        const updateYear = () => {
          applyYear(year);

          if (shouldStick) {
            enableStickyActions();
          }
        };

        if (document.startViewTransition) {
          document.startViewTransition(updateYear);
          return;
        }

        updateYear();
      };

      yearButtons.forEach((button) => {
        button.addEventListener('click', () => setYear(button.dataset.jloYear, true));
      });

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', syncStickyActions);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(syncStickyActions);
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              section.classList.remove('jlo--sticky-actions');
            }
          });
        }, { threshold: 0.05 });

        observer.observe(section);
      }

      applyYear(section.dataset.jloActiveYear || 'reception');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
